<dialog-header [label]="'FIELDS.CREATE_SENSOR' | translate" *ngIf="!sensor" [dialogRef]='dialogRef' [object]='this'
  [objectType]='"Sensor"' (mousedown)="windowClick()"></dialog-header>

<div fxLayout="column" style="overflow-y: auto; max-height: 600px;" (mousedown)="windowClick()">
  <!-- Basic -->
  <mat-accordion>
    <mat-expansion-panel style="margin: 0px;" [expanded]="!sensor">
      <mat-expansion-panel-header class="collapsable"
        [@blinkError]="activeAnim[0].length > 0 ? 'red' : 'normal'">
        <mat-panel-title fxLayoutAlign="center center" style="user-select: none; margin-right: 0px;">
          {{'FIELDS.BASIC' | translate}}{{!sensor ? '*' : ''}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div *ngIf="!sensor">
        <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
          <app-basic-field-number-w #sic fxFlex [RealValue]="undefined" [Title]="'FIELDS.SIC' | translate" [MinVal]=0
            [MaxVal]=99 [MaxNumsAfterDot]=0 [Required]=true
            (TriggerOutsideErrorAnim)="collapsableAnimController(0, $event)" [MaxLength]=2>
          </app-basic-field-number-w>
          <app-basic-field-number-w #sac fxFlex [RealValue]="undefined" [Title]="'FIELDS.SAC' | translate" [MinVal]=0
            [MaxVal]=99 [MaxNumsAfterDot]=0 [Required]=true
            (TriggerOutsideErrorAnim)="collapsableAnimController(0, $event)" [MaxLength]=2>
          </app-basic-field-number-w>
        </div>
      </div>

      <mat-radio-group [(ngModel)]="dimension" fxLayout="column" fxLayoutAlign="center center">
        <label>{{'NAT_NAI.GEOMETRIC_SHAPE' | translate}}</label>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="track-data-margin-top-and-bottom-no-border">
          <mat-radio-button [value]=0 style="margin-right: 30px;">{{'FIELDS.2D' | translate}}</mat-radio-button>
          <mat-radio-button [value]=1>{{'FIELDS.3D' | translate}}</mat-radio-button>
        </div>
      </mat-radio-group>

      <div fxLayout="row" fxLayoutAlign="space-around-center" class="track-data-margin-top-and-bottom-no-border">
        <app-checkbox-field #logiConn fxFlex="100" [RealValue]="sensor != undefined ? sensor.logiConn : undefined"
          [Title]="'FIELDS.LOGICALLY_CONNECTED' | translate">
        </app-checkbox-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-basic-field-w #sensorLetter fxFlex [RealValue]="sensor != undefined ? sensor.sensorLetter : undefined"
          [Title]="'FIELDS.LETTER' | translate" [MaxLength]=1 [MinLength]=1 [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(0, $event)">
        </app-basic-field-w>
        <app-basic-field-w #sensorName fxFlex [RealValue]="sensor != undefined ? sensor.name : undefined"
          [Title]="'FIELDS.NAME' | translate" [MaxLength]=15 [MinLength]=1 [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(0, $event)">
        </app-basic-field-w>
      </div>
      <div style="margin-top: 15px;"></div>
      <app-coords #coords [isEditOnly]="true" [Required]="!sensor" [Geo]="sensor ? sensor.geometry : undefined"
        (TriggerOutsideErrorAnim)="collapsableAnimController(0, $event)"></app-coords>
      <div style="margin-top: 15px;"></div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-long-distance-field-w #altitude fxFlex
          [RealValue]="sensor != undefined ? (sensor.geometry.z / 1000) : undefined"
          [Title]="'FIELDS.HEIGHT' | translate" [MinVal]=-1 [MaxVal]=9000 [MaxNumsAfterDot]=4 [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(0, $event)">
        </app-long-distance-field-w>
        <app-basic-field-number-w #scanTime fxFlex [RealValue]="sensor != undefined ?sensor.scanTime : undefined"
          [Title]="'FIELDS.SCAN_TIME' | translate" [MinVal]=1 [MaxVal]=30 [MaxNumsAfterDot]=1 [Required]="!sensor"
          [Comment]="'UNITS.SECONDS' | translate" (TriggerOutsideErrorAnim)="collapsableAnimController(0, $event)">
        </app-basic-field-number-w>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <!-- General -->
  <mat-accordion>
    <mat-expansion-panel style="margin: 0px;">
      <mat-expansion-panel-header class="collapsable"
        [@blinkError]="activeAnim[1].length > 0   ? 'red' : 'normal'">
        <mat-panel-title fxLayoutAlign="center center" style="user-select: none; margin-right: 0px;">
          {{'FIELDS.GENERAL' | translate}}{{!sensor ? '*' : ''}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-distance-field-w #minRange fxFlex [RealValue]="sensor != undefined ?sensor.minRange : undefined"
          [Title]="'FIELDS.MIN_RANGE' | translate" [MinVal]=0 [MaxVal]=99999 [MaxNumsAfterDot]=0 [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(1, $event)">
        </app-distance-field-w>
        <app-distance-field-w #maxRange fxFlex [RealValue]="sensor != undefined ?sensor.maxRange : undefined"
          [Title]="'FIELDS.MAX_RANGE' | translate" [MinVal]=0 [MaxVal]=999999 [MaxNumsAfterDot]=0 [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(1, $event)">
        </app-distance-field-w>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-distance-field-w #maxHeight fxFlex [RealValue]="sensor != undefined ?sensor.maxHeight : undefined"
          [Title]="'FIELDS.MAX_HEIGHT' | translate" [MinVal]=0 [MaxVal]=99999999 [MaxNumsAfterDot]=0
          [Required]="!sensor" (TriggerOutsideErrorAnim)="collapsableAnimController(1, $event)">
        </app-distance-field-w>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around-center" class="track-data-margin-top-and-bottom-no-border">
        <app-checkbox-field #SSRCapable fxFlex="100" [RealValue]="sensor != undefined ? sensor.SSRCapable : undefined"
          [callBack]="SSRCheckBoxCallBack" [Title]="'FIELDS.SSR_CAPABLE' | translate">
        </app-checkbox-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-distance-field-w #SSRMinRange fxFlex [RealValue]="sensor != undefined ?sensor.SSRMinRange : undefined"
          [Title]="'FIELDS.SSR_MIN_RNG' | translate" [MinVal]=0 [MaxVal]=99999 [MaxNumsAfterDot]=0 [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(1, $event)">
        </app-distance-field-w>
        <app-distance-field-w #SSRMaxRange fxFlex [RealValue]="sensor != undefined ?sensor.SSRMaxRange : undefined"
          [Title]="'FIELDS.SSR_MAX_RNG' | translate" [MinVal]=0 [MaxVal]=999999 [MaxNumsAfterDot]=0 [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(1, $event)">
        </app-distance-field-w>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <!-- Biases -->
  <mat-accordion>
    <mat-expansion-panel style="margin: 0px;">
      <mat-expansion-panel-header class="collapsable"
        [@blinkError]="activeAnim[2].length > 0   ? 'red' : 'normal'">
        <mat-panel-title fxLayoutAlign="center center" style="user-select: none; margin-right: 0px;">
          {{'FIELDS.BIASES' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxLayout="row" fxLayoutAlign="space-around-center" class="track-data-margin-top-and-bottom-no-border">
        <app-checkbox-field #PSRReg fxFlex="50" [RealValue]="sensor != undefined ?sensor.PSRReg : undefined"
          [Title]="'FIELDS.PSR_REGISTERED' | translate" [callBack]="PSRRegCheckBoxCallBack">
        </app-checkbox-field>
        <app-checkbox-field #SSRReg fxFlex="50" [RealValue]="sensor != undefined ?sensor.SSRReg : undefined"
          [Title]="'FIELDS.SSR_REGISTERED' | translate" [callBack]="SSRRegCheckBoxCallBack">
        </app-checkbox-field>
      </div>
      <app-checkbox-field #ALT_REGISTERED [RealValue]="sensor != undefined ?sensor.ALTReg : undefined"
        [Title]="'FIELDS.ALT_REGISTERED' | translate" [callBack]="ALTRegCheckBoxCallBack">
      </app-checkbox-field>
      <!-- <mat-divider></mat-divider> -->
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-basic-field-number-w #azimuthBias fxFlex [RealValue]="sensor != undefined ?sensor.azimuthBias : undefined"
          [Title]="'FIELDS.AZIMUTH' | translate" [MinVal]=0 [MaxVal]=360 [MaxNumsAfterDot]=5 [FrontDecor]="'°'"
          [Comment]="'UNITS.DEGREES' | translate" (TriggerOutsideErrorAnim)="collapsableAnimController(2, $event)"
          [Required]="!sensor">
        </app-basic-field-number-w>
        <!-- degrees -->
        <app-distance-field-w #rangeBias fxFlex [RealValue]="sensor != undefined ?sensor.rangeBias : undefined"
          [Title]="'FIELDS.RANGE' | translate" [MinVal]=-500 [MaxVal]=500 [MaxNumsAfterDot]=0
          (TriggerOutsideErrorAnim)="collapsableAnimController(2, $event)" [Required]="!sensor"></app-distance-field-w>
        <!-- distance -->
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-distance-field-w #heightBias fxFlex [RealValue]="sensor != undefined ?sensor.heightBias : undefined"
          [Title]="'FIELDS.HEIGHT' | translate" [MinVal]=-500 [MaxVal]=500 [MaxNumsAfterDot]=0
          (TriggerOutsideErrorAnim)="collapsableAnimController(2, $event)" [Required]="!sensor"></app-distance-field-w>
        <!-- degrees -->
        <app-basic-field-number-w #elevationBias fxFlex
          [RealValue]="sensor != undefined ?sensor.elevationBias : undefined" [Title]="'FIELDS.ELEVATION' | translate"
          [MinVal]=0 [MaxVal]=360 [MaxNumsAfterDot]=5 [FrontDecor]="'°'" [Comment]="'UNITS.DEGREES' | translate"
          (TriggerOutsideErrorAnim)="collapsableAnimController(2, $event)" [Required]="!sensor">
        </app-basic-field-number-w>
        <!-- distance -->
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-basic-field-number-w #SSRAzimuthBias fxFlex
          [RealValue]="sensor != undefined ?sensor.SSRAzimuthBias : undefined"
          [Title]="'FIELDS.SSR_AZIMUTH' | translate" [MinVal]=0 [MaxVal]=360 [MaxNumsAfterDot]=5 [FrontDecor]="'°'"
          [Comment]="'UNITS.DEGREES' | translate" (TriggerOutsideErrorAnim)="collapsableAnimController(2, $event)"
          [Required]="!sensor">
        </app-basic-field-number-w> <!-- degrees -->
        <app-distance-field-w #SSRRangeBias fxFlex [RealValue]="sensor != undefined ?sensor.SSRRangeBias : undefined"
          [Title]="'FIELDS.SSR_RANGE' | translate" [MinVal]=-500 [MaxVal]=500 [MaxNumsAfterDot]=0
          (TriggerOutsideErrorAnim)="collapsableAnimController(2, $event)" [Required]="!sensor">
        </app-distance-field-w>
        <!-- distance -->
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-distance-field-w #locXBias fxFlex [RealValue]="sensor != undefined ?sensor.locXBias : undefined"
          [Title]="'FIELDS.LOCATIONX' | translate" [MinVal]=-2000 [MaxVal]=2000 [MaxNumsAfterDot]=0
          (TriggerOutsideErrorAnim)="collapsableAnimController(2, $event)">
        </app-distance-field-w>
        <!-- distance -->
        <app-distance-field-w #locYBias fxFlex [RealValue]="sensor != undefined ?sensor.locYBias : undefined"
          [Title]="'FIELDS.LOCATIONY' | translate" [MinVal]=-2000 [MaxVal]=2000 [MaxNumsAfterDot]=0
          (TriggerOutsideErrorAnim)="collapsableAnimController(2, $event)">
        </app-distance-field-w>
        <!-- distance -->
      </div>
      <app-checkbox-field #locConfidence [RealValue]="sensor != undefined ?sensor.locConfidence : undefined"
        [Title]="'FIELDS.LOCATIONCONFIDENCE' | translate" [callBack]="LocConfCheckBoxCallBack"></app-checkbox-field>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-distance-field-w #locBiasXError fxFlex [RealValue]="sensor != undefined ?sensor.locBiasXError : undefined"
          [Title]="'FIELDS.LOCATIO_BIAS_ERR_X' | translate" [MinVal]=-2000 [MaxVal]=2000 [MaxNumsAfterDot]=0
          (TriggerOutsideErrorAnim)="collapsableAnimController(2, $event)">
        </app-distance-field-w> <!-- distance -->
        <app-distance-field-w #locBiasYError fxFlex [RealValue]="sensor != undefined ?sensor.locBiasYError : undefined"
          [Title]="'FIELDS.LOCATIO_BIAS_ERR_Y' | translate" [MinVal]=-2000 [MaxVal]=2000 [MaxNumsAfterDot]=0
          (TriggerOutsideErrorAnim)="collapsableAnimController(2, $event)">
        </app-distance-field-w> <!-- distance -->
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <!-- Errors -->
  <mat-accordion>
    <mat-expansion-panel style="margin: 0px;">
      <mat-expansion-panel-header class="collapsable"
        [@blinkError]="activeAnim[3].length > 0   ? 'red' : 'normal'">
        <mat-panel-title fxLayoutAlign="center center" style="user-select: none; margin-right: 0px;">
          {{'FIELDS.ERRORS' | translate}}{{!sensor ? '*' : ''}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-basic-field-number-w #azimuthError fxFlex
          [RealValue]="sensor != undefined ?sensor.azimuthError : undefined" [Title]="'FIELDS.AZIMUTH' | translate"
          [MinVal]=0 [MaxVal]=360 [MaxNumsAfterDot]=5 [FrontDecor]="'°'" [Comment]="'UNITS.DEGREES' | translate"
          [Required]="!sensor" (TriggerOutsideErrorAnim)="collapsableAnimController(3, $event)">
        </app-basic-field-number-w>
        <!-- degrees -->
        <app-distance-field-w #rangeError fxFlex [RealValue]="sensor != undefined ?sensor.rangeError : undefined"
          [Title]="'FIELDS.RANGE' | translate" [MinVal]=-500 [MaxVal]=500 [MaxNumsAfterDot]=0 [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(3, $event)">
        </app-distance-field-w>
        <!-- distance -->
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-distance-field-w #heightError fxFlex [RealValue]="sensor != undefined ?sensor.heightError : undefined"
          [Title]="'FIELDS.HEIGHT' | translate" [MinVal]=-500 [MaxVal]=500 [MaxNumsAfterDot]=0 [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(3, $event)">
        </app-distance-field-w>
        <!-- degrees -->
        <app-basic-field-number-w #elevationError fxFlex
          [RealValue]="sensor != undefined ?sensor.elevationError : undefined" [Title]="'FIELDS.ELEVATION' | translate"
          [MinVal]=0 [MaxVal]=360 [MaxNumsAfterDot]=5 [FrontDecor]="'°'" [Comment]="'UNITS.DEGREES' | translate"
          [Required]="!sensor" (TriggerOutsideErrorAnim)="collapsableAnimController(3, $event)">
        </app-basic-field-number-w>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-basic-field-number-w #SSRAzimuthError fxFlex
          [RealValue]="sensor != undefined ?sensor.SSRAzimuthError : undefined"
          [Title]="'FIELDS.SSR_AZIMUTH' | translate" [MinVal]=0 [MaxVal]=360 [MaxNumsAfterDot]=5 [FrontDecor]="'°'"
          [Comment]="'UNITS.DEGREES' | translate" [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(3, $event)">
        </app-basic-field-number-w>
        <app-distance-field-w #SSRRangeError fxFlex [RealValue]="sensor != undefined ?sensor.SSRRangeError : undefined"
          [Title]="'FIELDS.SSR_RANGE' | translate" [MinVal]=-500 [MaxVal]=500 [MaxNumsAfterDot]=0 [Required]="!sensor"
          (TriggerOutsideErrorAnim)="collapsableAnimController(3, $event)">
        </app-distance-field-w>
        <!-- distance -->
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-speed-field-w #rangeRateError fxFlex [RealValue]="sensor != undefined ?sensor.rangeRateError : undefined"
          [Title]="'FIELDS.RANGERATE_ERROR' | translate" [MinVal]=0 [MaxVal]=9999 [MaxNumsAfterDot]=1
          [Required]="!sensor" (TriggerOutsideErrorAnim)="collapsableAnimController(3, $event)">
        </app-speed-field-w>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <!-- Plots -->
  <mat-accordion *ngIf="false">
    <mat-expansion-panel style="margin: 0px;">
      <mat-expansion-panel-header>
        <mat-panel-title fxLayoutAlign="center center" fxLayoutGap="5px" style="user-select: none; margin-right: 0px;">
          {{'FIELDS.PLOTS' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-basic-field-number-r fxFlex [RealValue]="sensor != undefined ?sensor.SRPlots : undefined"
          [Title]="'FIELDS.TOTAL_SR_PLOTS' | translate" [MaxNumsAfterDot]=0></app-basic-field-number-r>
        <app-basic-field-number-r fxFlex [RealValue]="sensor != undefined ?sensor.SRRejPlots : undefined"
          [Title]="'FIELDS.TOTAL_REJ_SR_PLOTS' | translate" [MaxNumsAfterDot]=0></app-basic-field-number-r>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-basic-field-number-r fxFlex [RealValue]="sensor != undefined ?sensor.SSRPlots : undefined"
          [Title]="'FIELDS.TOTAL_SSR_PLOTS' | translate" [MaxNumsAfterDot]=0></app-basic-field-number-r>
        <app-basic-field-number-r fxFlex [RealValue]="sensor != undefined ?sensor.SSRRejPlots : undefined"
          [Title]="'FIELDS.TOTAL_REJ_SSR_PLOTS' | translate" [MaxNumsAfterDot]=0></app-basic-field-number-r>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-around center" class="track-data-margin-top-and-bottom-no-border">
        <app-basic-field-number-r fxFlex [RealValue]="sensor != undefined ?sensor.strobes : undefined"
          [Title]="'FIELDS.TOTAL_STROBES' | translate" [MaxNumsAfterDot]=0>
        </app-basic-field-number-r>
        <app-basic-field-number-r fxFlex [RealValue]="sensor != undefined ?sensor.rejStrobes : undefined"
          [Title]="'FIELDS.TOTAL_REJ_STROBES' | translate" [MaxNumsAfterDot]=0></app-basic-field-number-r>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <!-- Nai-Nat -->
  <mat-accordion *ngIf="sensor">
    <mat-expansion-panel>
      <mat-expansion-panel-header *ngIf="sensor.naiNatArray && sensor.naiNatArray.length > 0">
        <mat-panel-title fxLayoutAlign="center center" fxLayoutGap="5px" style="user-select: none; margin-right: 0px;">
          {{'ARO.NAT_NAI_TITLE' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxLayout="row" class="sensor-natnai">
        <form>
          <mat-selection-list dense>
            <mat-list-option class="selection-list-option" checkboxPosition="before"
              *ngFor="let item of sensor.naiNatArray; index as i"
              [selected]="sensor.naiNatArray[i].isVisible && sensor.isNatNaiVisible" (click)="onNatNaiBtnClick(i)">
              {{item.naiOrNat == 1 ? 'Nai':'Nat'}} {{item.naiNatId}}
            </mat-list-option>
          </mat-selection-list>
        </form>
      </div>
      <div *ngIf="sensor.naiNatArray && sensor.naiNatArray.length > 0" fxLayoutAlign="center center">
        <button class="button-border-margin" mat-stroked-button
          (click)="selectOrRemoveAllNatNai(true)">{{'ACTIONS.SHOW_ALL' | translate}}</button>
        <button class="button-border-margin" mat-stroked-button
          (click)="selectOrRemoveAllNatNai(false)">{{'ACTIONS.HIDE_ALL' | translate}}</button>
        <button class="button-border-margin" mat-stroked-button (click)="deleteSelectedNatNai()">
          {{'ACTIONS.DELETE' | translate}}</button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <!-- lab stuff -->
  <!-- 
  <mat-accordion>
    <mat-expansion-panel style="margin: 0px;">
      <mat-expansion-panel-header>
        <mat-panel-title fxLayoutAlign="center center" fxLayoutGap="5px" style="user-select: none">
          Generic String Component
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-basic-field #dist [RealValue]="sensor.geometry.z" [Title]="'Vel Z'"></app-basic-field>
      <app-basic-field #dist [RealValue]="sensor.geometry.z" [Title]="'Vel Z'" [Comment]="'mi ze?'"></app-basic-field>
      <app-basic-field-w [RealValue]="sensor.geometry.z" [Title]="'Vel Z'" [MaxLength]=20></app-basic-field-w>
      <app-basic-field-r [RealValue]="sensor.geometry.z" [Title]="'Vel Z'"></app-basic-field-r>
      <app-checkbox-field [RealValue]="true" [Title]="'sup sup!'"></app-checkbox-field>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <mat-expansion-panel style="margin: 0px;">
      <mat-expansion-panel-header>
        <mat-panel-title fxLayoutAlign="center center" fxLayoutGap="5px" style="user-select: none">
          Generic Number Component
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-basic-field-number [RealValue]="sensor.geometry.z" [Title]="'Vel Z'"></app-basic-field-number>
      <app-basic-field-number-w [RealValue]="sensor.geometry.z" [Title]="'Vel Z'"></app-basic-field-number-w>
      <app-basic-field-number-r [RealValue]="sensor.geometry.z" [Title]="'Vel Z'"></app-basic-field-number-r>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <mat-expansion-panel style="margin: 0px;">
      <mat-expansion-panel-header>
        <mat-panel-title fxLayoutAlign="center center" fxLayoutGap="5px" style="user-select: none">
          Distance Component
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-distance-field [RealValue]="sensor.geometry.z" [Title]="'Vel Z'"></app-distance-field>
      <app-distance-field-w [RealValue]="sensor.geometry.z" [Title]="'Vel Z'"></app-distance-field-w>
      <app-distance-field-r [RealValue]="sensor.geometry.z" [Title]="'Vel Z'"></app-distance-field-r>
    </mat-expansion-panel>
  </mat-accordion> -->
</div>
<div fxLayoutAlign="center center">
  <button class="button-border-margin" mat-stroked-button (click)="updateNow()">
    {{'ACTIONS.SEND' | translate}} </button>
</div>